<template>
  <!-- Candidate modal -->
  <CandidateDetails
    v-model="$parent.candidateModal"
    ref="candidateDetails"
    size="full"
    :item="$parent.candidateSelected"
    :communes="$parent.communesAll"
    :organization-types="$parent.organizationTypes"
    :countries="$parent.countries"
    :locale="$parent.config.locale"
    :pre-selected-tab="$parent.candidateSelectedTab"
    @change-tab="$parent.onCandidateTabChange"
    :close-button="false"
  />
</template>

<script>
export default {
  name: 'Candidate',

  props: [],

  data: function () {
    return {
      candidate: null,
    }
  },

  mounted () {
    this.candidate = this.$parent.candidates.find(item => {
      return item.id == this.$route.params.candidateId || item.name == this.$route.params.candidateId
    })
  },
}
</script>
